import styled from "styled-components";
import { variant, textAlign } from "styled-system";
import { apolloSpaceInset1HalfX, apolloSpaceInset1X, apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
import { getTableColumnWidthProps } from "./TableColumn";
import { MINI_TAG_HEIGHT } from "../mini-tag/MiniTag.style";
import apolloTheme from "../../theme/Theme";
import { Flex } from "../box";
import { getJustifyContentFromTextAlign } from "./utils";
import { MiniTagList } from "../mini-tag";
import Box from "../box/Box";
import { lineClamp } from "../../utils/StyleUtils";
import { HiddenButtonIcon } from "../menu/KebabActionMenu.style";
const HEADER_Y_PADDING_WITH_TAGS = 6;
export const HEADER_MAX_HEIGHT = `calc(${HEADER_Y_PADDING_WITH_TAGS}px * 2 + ${apolloTheme.textStyles.heading6.lineHeight} + ${MINI_TAG_HEIGHT}px)`;
export const StyledTableHeaderCell = styled.div.withConfig({ displayName: "StyledTableHeaderCell_APC-7281-productShell", componentId: "sc-18qdls2" })(({ theme, column, column: { sortable, minWidth } }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ cursor: sortable ? "pointer" : "auto", padding: `${HEADER_Y_PADDING_WITH_TAGS / 2}px ${apolloSpaceInset1X}` }, (column.type === "TableSelectionColumn" && {
    padding: `calc(${apolloSpaceInset1HalfX} - 1px) calc(${apolloSpaceInset1X} - 1px) `,
})), { minWidth }), getTableColumnWidthProps(column)), { height: HEADER_MAX_HEIGHT, boxSizing: "border-box", color: theme.colors.apolloColorTextSecondary }), theme.textStyles.heading6), { display: "flex", alignItems: "center", justifyContent: getJustifyContentFromTextAlign(column.align), [`&:hover ${HiddenButtonIcon}, &:focus-within ${HiddenButtonIcon}`]: {
        opacity: 1,
    } })), textAlign, () => variant({
    prop: "$type",
    variants: {
        TableFillerColumn: {
            padding: "0 !important",
        },
    },
}));
export const StyledKebabButton = styled.span.withConfig({ displayName: "StyledKebabButton_APC-7281-productShell", componentId: "sc-4n43uv" })(({ theme }) => ({
    display: "inline-block",
    verticalAlign: "middle",
    marginLeft: apolloSpaceInsetHalfX,
    "& svg": {
        color: `${theme.colors.apolloColorTextSecondary} !important`,
    },
}));
export const StyledSingleLineEllipsis = styled.div.withConfig({ displayName: "StyledSingleLineEllipsis_APC-7281-productShell", componentId: "sc-8p8y80" })({
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
    WebkitLineClamp: "1",
    whiteSpace: "nowrap",
});
export const StyledTableHeaderContent = styled.span.withConfig({ displayName: "StyledTableHeaderContent_APC-7281-productShell", componentId: "sc-19wao1u" })(({ sortable, tableLayout, withTags }) => {
    return Object.assign(Object.assign(Object.assign(Object.assign({ minWidth: 0, maxHeight: "34px", overflow: "hidden" }, (tableLayout !== "squeeze" && {
        width: "max-content",
    })), { ".LinesEllipsis": Object.assign(Object.assign({}, lineClamp(2)), (tableLayout === "squeeze" && {
            wordBreak: "keep-all",
            wordWrap: "break-word",
        })) }), (withTags && {
        overflow: "hidden",
    })), (sortable && {
        borderTop: "1px solid transparent",
        borderBottom: "1px solid transparent",
        // fixes cropped focus border in Safari
        boxDecorationBreak: "clone",
    }));
});
export const StyledHeaderContentWrapper = styled(Flex).withConfig({ displayName: "StyledHeaderContentWrapper_APC-7281-productShell", componentId: "sc-v7foet" })(({ column }) => ({
    minWidth: 0,
    alignItems: "center",
    justifyContent: getJustifyContentFromTextAlign(column.align),
}));
export const StyledMiniTagList = styled(MiniTagList).withConfig({ displayName: "StyledMiniTagList_APC-7281-productShell", componentId: "sc-18bj62r" })(({ column }) => ({
    whiteSpace: "nowrap",
    overflow: "hidden",
    justifyContent: getJustifyContentFromTextAlign(column.align),
}));
export const StyledHeaderWithTags = styled(Box).withConfig({ displayName: "StyledHeaderWithTags_APC-7281-productShell", componentId: "sc-196mcyz" })({
    minWidth: 0,
    flex: 1,
});
//# sourceMappingURL=TableHeaderCell.style.js.map